export const DEFAULT_VARIANT = 'default'
